module.exports = __webpack_public_path__ + "static/img/3.ab86ff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/partners/3.png
// module id = 02om
// module chunks = 3